const UPDATE_PODCAST = '_podcast/UPDATE_PODCAST';

export default {
  UPDATE_PODCAST,
};
